const getListPredefinedNoteMock = {
  notes: [
    {
      id: '1',
      name: 'Template 1',
      text: 'This is the text for Template 1.',
      resourceId: 'SERVICE_CASE',
      context: 'service_order',
    },
    {
      id: '2',
      name: 'Template 2',
      text: 'This is the text for Template 2.',
      resourceId: 'SERVICE_CASE',
      context: 'service_order',
    },
  ],
};

export const predefinedNoteMock = {
  getListPredefinedNoteMock,
};
